import PropTypes from "prop-types";
import { Avatar, Typography, Box } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";

/**
 * Layout wrapper for unauthenticated pages (sign in, sign up, forgot/reset password).
 * Renders a centered column with a lock avatar, a heading, and children content.
 *
 * @param {object} props
 * @param {React.ReactNode} props.title - Page heading content.
 * @param {React.ReactNode} props.children - Page body content.
 */
function AuthPageLayout({ title, children }) {
  return (
    <Box
      sx={{
        marginTop: 8,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}>
      <Avatar sx={{ m: 1, bgcolor: "secondary.main" }}>
        <LockOutlinedIcon />
      </Avatar>
      <Typography component="h1" variant="h5">
        {title}
      </Typography>
      {children}
    </Box>
  );
}

AuthPageLayout.propTypes = {
  title: PropTypes.node.isRequired,
  children: PropTypes.node.isRequired,
};

export default AuthPageLayout;
